import { Stack, Box, Typography, Button } from "@mui/material";
import Indicator from "@components/molecules/Indicator/Indicator";
import GenericTable from "../GenericTable/GenericTable";
import { IHomeUI } from "src/types/organisms";
import { grey, blue, teal, orange } from "@mui/material/colors";
import { Wallet2, ReceiptCutoff, BoxArrowInDown } from "react-bootstrap-icons";
import ErrorAlert from "@components/atoms/ErrorAlert/ErrorAlert";
import TitlePage from "@components/atoms/TitlePage/TitlePage";
import ReceiptFilters from "@components/molecules/ReceiptFilters/ReceiptFilters";
const HomeUI = ({
  isLoading,
  showError,
  closeError,
  errorMessage,
  headers,
  rows,
  onClick,
  pages,
  currentPage,
  onChangePage,
  onSearch,
  onSearchClick,
  startDate,
  endDate,
  indicators,
  isAdmin,
  toggleIndicators,
  handleStatusFilter,
  handleExpiredFilter
}: IHomeUI) => {
  return <>
      {isAdmin ? <>
          <Stack direction={"row"} justifyContent={"space-between"} alignItems={"flex-end"}>
            <Box>
              <Typography variant="h5" fontWeight={700} marginBottom={1}>
                Resumen de mes
              </Typography>
              <Typography color={grey[600]}>
                Saldos desde el {startDate.split("-").reverse().join("/")} al{" "}
                {endDate.split("-").reverse().join("/")}
              </Typography>
            </Box>
            <Button disableElevation={false} sx={{
          fontSize: ".9rem"
        }} onClick={toggleIndicators}>
              {indicators.totalPaidSum === "---" ? "Mostrar resumen" : "Ocultar resumen"}
            </Button>
          </Stack>
          <Stack direction={"row"} marginTop={4} spacing={3}>
            <Indicator color={blue[300]} icon={<Wallet2 color="white" size={36} />} label="Saldo en cartera" value={`${indicators.totalRequestSum} COP`} />
            <Indicator color={orange[300]} icon={<ReceiptCutoff color="white" size={36} />} label="Saldo abonado" value={`${indicators.totalPaidSum} COP`} />
            <Indicator color={teal[300]} icon={<BoxArrowInDown color="white" size={36} />} label="Saldo en devoluciones" value={`${indicators.totalReturnSum} COP`} />
          </Stack>
        </> : <TitlePage title="Recibos de caja" subtitle="Supervisa el estado de tus recibos y sus clientes de manera centralizada." />}
      <GenericTable isLoading={isLoading} title="Lista de recibos de caja" buttonLabel="Crear recibo" onClick={onClick} headers={headers} rows={rows} pages={pages} currentPage={currentPage} onChangePage={onChangePage} emptyMessage="Sin recibos encontrados" searchLabel="Buscar cliente" onSearch={onSearch} onSearchClick={onSearchClick} moreFilters={<ReceiptFilters handleExpiredFilter={handleExpiredFilter} handleStatusFilter={handleStatusFilter} />} />
      <ErrorAlert open={showError} onClose={closeError} message={errorMessage} />
    </>;
};
export default HomeUI;